export const SCREEN_NAMES = {
	SYNCED_TRANSACTIONS: "SyncedTransactions",
	RECURRING_TRANSACTIONS: "RecurringTransactions",
	PARENT_CHILD_CATEGORIES: "ParentChildCategories",
	FORECAST_TRANSACTIONS: "ForecastTransactions",
	SCENARIO_TRANSACTIONS: "ScenarioTransactions",
} as const;

export type ScreenName = (typeof SCREEN_NAMES)[keyof typeof SCREEN_NAMES];
